import { NuxtOptions } from '@nuxt/types'
import { LOGIN_PATH, ORDER_PATH } from '~/assets/config/path'
import { filterUrl } from '~/assets/filters/url'

export default function (context: NuxtOptions) {
  if (context.store.getters['site/getOptionsIsOnlyUserToAccessOrder']) {
    if (!context.$auth.loggedIn) {
      context.$cookies.set('auth.redirect', filterUrl(ORDER_PATH))
      return context.redirect(filterUrl(LOGIN_PATH))
    }
  }
}
